"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StyledRoot = (0, _styledBase["default"])("div", {
  target: "e1kkfya60",
  label: "StyledRoot"
})(function (_ref) {
  var theme = _ref.theme,
      styles = _ref.styles;
  return _objectSpread({
    boxSizing: 'border-box',
    color: theme.colors.base,
    fontFamily: theme.fonts.primary,
    fontSize: theme.fontSize,
    lineHeight: "".concat(theme.lineHeight, "px"),
    fontWeight: theme.fontWeight,
    '& *, & *::before, & *::after': {
      boxSizing: 'inherit'
    },
    '& [href], & [tabindex], & input, & textarea, & button, & select, & area': {
      '&:not([tabindex = "-1"]):focus': {
        outline: "2px auto ".concat(theme.colors.outline)
      }
    }
  }, styles);
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1Jlc2V0L2luZGV4LmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHbUIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvUmVzZXQvaW5kZXguanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmNvbnN0IFN0eWxlZFJvb3QgPSBzdHlsZWQuZGl2KCh7IHRoZW1lLCBzdHlsZXMgfSkgPT4gKHtcbiAgYm94U2l6aW5nOiAnYm9yZGVyLWJveCcsXG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMuYmFzZSxcbiAgZm9udEZhbWlseTogdGhlbWUuZm9udHMucHJpbWFyeSxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplLFxuICBsaW5lSGVpZ2h0OiBgJHt0aGVtZS5saW5lSGVpZ2h0fXB4YCxcbiAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodCxcbiAgJyYgKiwgJiAqOjpiZWZvcmUsICYgKjo6YWZ0ZXInOiB7XG4gICAgYm94U2l6aW5nOiAnaW5oZXJpdCcsXG4gIH0sXG4gICcmIFtocmVmXSwgJiBbdGFiaW5kZXhdLCAmIGlucHV0LCAmIHRleHRhcmVhLCAmIGJ1dHRvbiwgJiBzZWxlY3QsICYgYXJlYSc6IHtcbiAgICAnJjpub3QoW3RhYmluZGV4ID0gXCItMVwiXSk6Zm9jdXMnOiB7XG4gICAgICBvdXRsaW5lOiBgMnB4IGF1dG8gJHt0aGVtZS5jb2xvcnMub3V0bGluZX1gLFxuICAgIH0sXG4gIH0sXG4gIC4uLnN0eWxlcyxcbn0pKVxuXG5jb25zdCBSZXNldCA9ICh7IGNoaWxkcmVuLCBjbGFzc05hbWUsIHN0eWxlcyB9KSA9PiAoXG4gIDxTdHlsZWRSb290IGNsYXNzTmFtZT17Y2xhc3NOYW1lfSBzdHlsZXM9e3N0eWxlc30+e2NoaWxkcmVufTwvU3R5bGVkUm9vdD5cbilcblxuUmVzZXQucHJvcFR5cGVzID0ge1xuICBjaGlsZHJlbjogUHJvcFR5cGVzLmVsZW1lbnQuaXNSZXF1aXJlZCxcbiAgY2xhc3NOYW1lOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBzdHlsZXM6IFByb3BUeXBlcy5zaGFwZSh7fSksXG59XG5cblJlc2V0LmRlZmF1bHRQcm9wcyA9IHtcbiAgY2xhc3NOYW1lOiAnJyxcbiAgc3R5bGVzOiBudWxsLFxufVxuXG5SZXNldC5kaXNwbGF5TmFtZSA9ICdSZXNldCdcblxuZXhwb3J0IGRlZmF1bHQgUmVzZXRcbiJdfQ== */");

var Reset = function Reset(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      styles = _ref2.styles;
  return (0, _core.jsx)(StyledRoot, {
    className: className,
    styles: styles
  }, children);
};

Reset.propTypes = {
  children: _propTypes["default"].element.isRequired,
  className: _propTypes["default"].string,
  styles: _propTypes["default"].shape({})
};
Reset.defaultProps = {
  className: '',
  styles: null
};
Reset.displayName = 'Reset';
var _default = Reset;
exports["default"] = _default;